<div class="app-container">
    <app-toolbar></app-toolbar>
    <div class="main-content">
        <app-tool-panel></app-tool-panel>
        <div class="canvas-host">
            <app-canvas-editor></app-canvas-editor>
        </div>
        <app-right-panel></app-right-panel>
    </div>
</div>
